module.exports = __webpack_public_path__ + "media/dogs/green-dog-eating-01e4b7a3.svg";